import React from "react";

class MonthInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value
        };
    }

    handleChange(e) {
        this.setState({
            value: e.target.value
        }, this.props.onChange.bind(null, e.target.value));
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
            this.setState({ value: nextProps.value }, this.props.onChange.bind(null, nextProps.value));
        }
    }

    render() {
        return (
            <div className="month-input">
                <input type="tel"
                    name={this.props.name}
                    id={this.props.id}
                    aria-labelledby={this.props.labelId}
                    className={this.props.classes.input + this.props.questionInputClass}
                    min="01"
                    max="12"
                    placeholder="MM"
                    value={this.state.value}
                    required={this.props.required
                        ? 'required'
                        : undefined}
                    onChange={this.handleChange.bind(this)}
                    onBlur={this.props.onBlur.bind(null, this.state.value)}
                    onKeyDown={this.props.onKeyDown}
                />
            </div>
        );
    }
};

MonthInput.defaultProps = {
    classes: {},
    name: '',
    id: '',
    value: '',
    placeholder: '',
    onChange: () => {},
    onBlur: () => {},
    onKeyDown: () => {}
};

export default MonthInput;